import { Item } from '@inno-sdks/files'
import { queryOptions, useQuery } from '@tanstack/react-query'

import { initFilesSdk } from '../filesSdk'

export const getFileItemQueryOptions = <T extends Item>(id?: number) => {
  const { filesSdk, success } = initFilesSdk()

  return queryOptions({
    queryKey: ['file-item', id],
    queryFn: async () => {
      if (!filesSdk) return

      const res = await filesSdk.items.get({ id: id! })

      return res as T
    },

    enabled: success && Boolean(id)
  })
}

export const useGetFileItem = <T extends Item>(id?: number) => {
  return useQuery(getFileItemQueryOptions<T>(id))
}
